<template>
    <div>
            <top-navbar></top-navbar>
    
    
            <div class=" mb-5 background_color" >
              <h6 class="manage-boder pt-2 font1  decoration"> <a class="decoration" > Home </a><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><a class="decoration" > Service  </a><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><router-link class="decoration" to="/cmmsservicejob/index"> Manage Job   </router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>{{all_data.qu_code }} </h6>
                <!-- <img :src="imageUrl" alt="Your Image">
                <img src="../../../public/img/evenware-logo.png" width="140px" alt="Evenware Logo"> -->
            <div class="container-fluid">
                <!-- <h6 class="custom-maintitle mb-1"><b>{{ products.P_code }}  </b></h6> -->




                <div class="d-grid gap-2 d-md-flex justify-content-md-end">
       
                  <button v-if="all_data.status==3"  @click="Createinvoice()"  class="btn btn-sm  btn-outline-primary mb-1 bdr-rad">  Create Service Invoice</button>
                  
                  <button v-if="all_data.status==1"  @click="Update()"  class="btn btn-sm  btn-outline-primary mb-1 bdr-rad"> Update</button>
                  <button v-if="all_data.status==1"  @click="Confimmodel()"  class="btn btn-sm  btn-outline-primary mb-1 bdr-rad"> Confirm</button>
                  <button v-if="all_data.status!=1"  @click="generatePDF()"  class="btn btn-sm  btn-outline-primary mb-1 bdr-rad"> Print</button>
                
                 
            
                </div>
                <b-modal :id="infoModal1.id" 
     :header-bg-variant="headerBgVariant"
      :header-text-variant="headerTextVariant"
      
     bottom>
    <template   #modal-title>
     
      <h3 >Confirm !</h3>

      
  
    </template>
    
    <div class="d-block text-center">
      <h5>Are you sure you want to Confirm this item?</h5>
    </div>
    <hr>
    
    <template   #modal-footer>
    <button style="font-size: small;" @click="Confirm(infoModal1.content)" class="mr-1 btn btn-outline-primary btn-sm mb-1 bdr-rad">Yes</button>
    <button style="font-size: small;" @click="$bvModal.hide(infoModal1.id)" class="mr-1 btn btn-outline-primary btn-sm mb-1 bdr-rad">No</button>
    </template>

  
  </b-modal>

  
  <div class="card custom_bdr_rds shadow p-2" v-if="isLoading">
                  <div class="card-body custom_bdr_rds">

                <div class="d-flex justify-content-center" >
                  <div class="spinner-border text-primary" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                </div>

                  </div>
                </div>

                <div v-else class="mt-1">
                <div >




                <div class="card custom_bdr_rds shadow p-2">
                <div  class="card-body custom_bdr_rds">


                    <table style="font-size: small; " class="table table-hover  table-sm table-borderless table-responsive ">
       
                        <tbody >
                 
                         
                          <tr>
                            <td class="width-custom2"><b>Job Number</b></td>
                            <td>{{ all_data.qu_code }}</td>
                          </tr>
                          <tr>
                            <td><b>Job Category</b></td>
                            <td>{{ all_data.job_category === 'repair_job' ? 'Repair Job' : all_data.job_category }}</td>
                          </tr>
                          <tr>
                            <td><b>Asset Code</b></td>
                            <td>{{ all_data.p_code }}</td>
                          </tr>
                          <tr>
                            <td><b>Asset Description</b></td>
                            <td>{{ all_data.description }}</td>
                          </tr>
                          <tr>
                            <td><b>Scheduled Date</b></td>
                            <td>{{ all_data.scheduled_date }}</td>
                          </tr>
                          <tr>
                            <td><b>Remarks</b></td>
                            <td>{{ all_data.remarks }}</td>
                          </tr>
                          <tr>
                            <td><b>Status</b></td>
                            <td>{{ all_data.status_name || all_data.status }}</td>
                          </tr>
                          <tr>
                            <td><b>Created Date</b></td>
                            <td>{{ all_data.created_date }}</td>
                          </tr>
                         
                         
                          
                         
                           
                        </tbody>
                 
                 
                      </table>

                      </div>
                      </div>



                      <div v-if="details.length" class="card custom_bdr_rds shadow p-2">
                        <div class="card-body custom_bdr_rds">
                            <h6 class="purchitem mb-2"><b>Added Parts</b></h6>

                        <div class="table-responsive">

                        
                        <table style="font-size: small; " class="table table-hover table-sm table-borderless  ">
                            <thead  class="background_color2">
                              <tr class="custom-label2">
                              <th>#</th>
                              <th>Product</th>
                              <th class="text_right">Price</th>
                              <th class="text_right">Qty</th>
                              <th class="text_right">Discount</th>
                              <th class="text_right">Line Amount	</th>
                              <th class="text_right">GP Margin</th>
                              <th class="text_right">% GP Margin</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr  v-for="(detail, index) in details" :key="detail.id">
                              <td>{{ index+1 }}</td>
                              <td>{{detail.P_description}} ({{ detail.P_code }})</td>
                              <td class="text_right">{{detail.price}}</td>
                              <td class="text_right">{{detail.qty}}</td>
                              <td class="text_right">{{detail.line_discount}}</td>
                              <td class="text_right">{{detail.line_amount}}</td>
                              <td class="text_right">{{detail.gp_margin}}</td>
                              <td class="text_right">{{detail.gp_margin_precentage}}</td>
                              </tr>
                              <tr style="border-top: 2px solid black; " >
                              <td></td>
                              <th>Total :</th>
                              <td></td>
                              <td class="text_right">{{ total.total_qty }}</td>
                              <td></td>
                              <th class="text_right">{{ total.total_line_amount }}</th>
                              <th class="text_right">{{ total.total_gp_margin }}</th>
                              <th class="text_right">{{ total.total_gp_margin_precentage }}</th>
                              </tr>
                              <tr  >
                              <td></td>
                              <th>Special Discount :</th>
                              <td></td>
                              <td></td>
                              <td></td>
                              <th class="text_right">{{ total.special_discount }}</th>
                              <th class="text_right"></th>
                              <th class="text_right"></th>
                              </tr>
                              <tr  >
                              <td></td>
                              <th>Total :</th>
                              <td></td>
                              <td></td>
                              <td></td>
                              <th class="text_right">{{ total.sub_total }}</th>
                              <th class="text_right"></th>
                              <th class="text_right"></th>
                              </tr>
                            </tbody>

                          </table>


                        </div>
                    </div>
                </div>  





                 



                    <div class="card custom_bdr_rds shadow p-2">
              <div class="card-body custom_bdr_rds">
                  <h6 class="purchitem mb-2"><b>CRM Notes</b></h6>

                <div class="table-responsive">
           
              <table style="font-size: small; " class="table table-hover table-sm table-borderless ">
                  <thead  class="background_color2">
                    <tr class="custom-label2">
                    <th>#</th>
                    <th>Comment</th>
                    <th>Job Type</th>
                    <th>Created Date</th>
                    <th>Created By</th>
                    <th>Follow up Date	</th>
                    <th>Follow up by	</th>
                   
                    
                    </tr>
                  </thead>
                  <tbody>
                    <tr  v-for="(mservicelog, index) in mservicelogs" :key="mservicelog.idServicelog">
                    <td>{{index+1}}</td>
                    <td>{{ mservicelog.comments }}</td>
                    <td>{{ mservicelog.job_type }}</td>
                    <td>{{ mservicelog.created_date }} {{ mservicelog.created_time }}</td>
                    <td>{{ mservicelog.username }}</td>
                    <td>{{ mservicelog.followup_date }}</td>
                    <td>{{ mservicelog.followusername }}</td>
                   
                    
                    </tr>
                  </tbody>

                </table>
     </div>

          <br>


        

                <div class="row">
                  <div class="col-md-3">
                    <div class="form-group ">
                            <label class="custom-label" style="font-size: small;">Comments </label>
                            <textarea rows="3" v-model="crm.comments"  style="font-size: small;" class="form-control" ></textarea>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group ">
                            <label class="custom-label" style="font-size: small;">Job Type</label>
                            <select class="form-select" v-model="crm.job_type">
                              <option  selected>Select....</option>
                              <option >Vehicle Sales</option>
                              <option  >Spare Parts Sales</option>
                            </select>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group ">
                            <label class="custom-label" style="font-size: small;">Follow up Date</label>
                            <input v-model="crm.followup_date" type="date"  style="font-size: small;" class="form-control" >
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group ">
                            <label class="custom-label" style="font-size: small;">Follow up By</label>
                            <input v-model="username"  style="font-size: small;" class="form-control" disabled>
                    </div>
                  </div>


                </div>
           
                <div style="border-bottom: 0px; padding-top: 0px;" class="navbar">
    
                <div class="d-flex  ">
                
                </div>
                <div class="d-flex  ">
                    <button @click="crmCreate()"  class="mr-1 btn btn-outline-primary btn-sm  mb-0 mt-0 font-size_def bdr-rad">Add CRM Notes</button>
                </div>
                </div>

            </div>
        </div>
        <div class="card custom_bdr_rds shadow p-2">
                        <div class="card-body custom_bdr_rds">
                            <h6 class="purchitem mb-2"><b>Audit Trail</b></h6>

                            
                        <table style="font-size: small; " class="table table-hover table-sm table-borderless ">
                            <thead  class="background_color2">
                              <tr class="custom-label2">
                              <th>#</th>
                              <th>Field Name</th>
                              <th>Comment</th>
                              <th>Action</th>
                              <th>Created Date</th>
                              <th>Created Time</th>
                              <th>Created By</th>
                              <th>Previous Value</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr >
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              </tr>
                            </tbody>

                          </table>


                        </div>
                    </div>






   

<br><br>





                




                </div>
                </div>
              </div>
            </div>
    
            <!-- <vue-select label="value" style="z-index: 999;" v-model="selectedOption" :options="options" ></vue-select> <br><br><br><br><br><br> -->
            <content-footer></content-footer>
    </div>
    </template>
    <script>
   import jsPDF from 'jspdf';
   import 'jspdf-autotable';
     import axios from 'axios';
     import authService from '@/auth.service';
      import TopNavbar from './../../layout/TopNavbar.vue'
      import ContentFooter from './../../layout/ContentFooter.vue'
     
    
    
      export default {

        mounted(){
    this.loadSquatation()
      },
        data() {
          return {
            access_token:authService.isLoggedIn(),
            userid:authService.isUserid(),
            username:authService.isUsername(),
            'id':this.$route.query.id,
            total:{},
            all_data:{},
            category:{},
            brand:{},
            supplier:{},
            status:{},
            user:{},
          
            crm:{},
            details:[],
            mservicelogs:[],
            trans:[],
            width:5,
            height:5,
            isLoading: true,
            headerBgVariant: 'primary',
            headerTextVariant: 'white',
            infoModal1: {
          id: 'info-modal1',
          title: '',
          content: {},
        },

        // imageUrl: '/img/evenware-logo.png' 
           
          }
    
        },
        components :{
         
            ContentFooter,
            TopNavbar,
           
        },

        methods : {

          
          generatePDF() {
    
      const doc = new jsPDF();

      function addPageBorders(doc) {
    const pageWidth = doc.internal.pageSize.width;
    const pageHeight = doc.internal.pageSize.height;

    // Set the border style
    doc.setDrawColor(71, 144, 255); // Black color
    doc.setLineWidth(15); // Border width

    // Draw a line at the top of the page
    doc.line(0, 0, pageWidth, 0);
    // Draw a line at the bottom of the page
    doc.line(0, pageHeight, pageWidth, pageHeight);
}
     // Update this with your image URL or file path
   
      var img = new Image()
    img.src = '/img/evenware-logo.png'
    const imageWidth = doc.internal.pageSize.getWidth() - 550; // Adjust 20 if you need margins
  const imageHeight = (imageWidth * 3) / 4; // Assuming the aspect ratio is 4:3, adjust as needed
  
  doc.addImage(img, 'png', 10, 13, imageWidth, imageHeight);
  doc.setFontSize(18);
  doc.setFont('Helvetica', 'bold');
  doc.text('QUOTATION', 105, 30, null, null, 'center');
  doc.setFontSize(12);
  
  doc.text('Demonstration System', 10, 45, null, null);

  doc.setFont('Helvetica', 'normal');
  doc.setFontSize(8);
  doc.text('No 08, Rodrigo Mawatha,', 10, 48, null, null);
  doc.text('Nawala Road,', 10, 51, null, null);
  doc.text('Rajagiriya,', 10, 54, null, null);
  doc.text('Colombo 08,', 10, 57, null, null);
  doc.text('Sri Lanka', 10, 60, null, null);
  doc.text('Tel : 0112 806 776-9,', 10, 63, null, null);
  doc.text('Web : colombo@cmc.slt.lk ,', 10, 66, null, null);


  doc.setFontSize(10);
  doc.setFont('Helvetica', 'bold');
  doc.text('Quotation To:', 85, 45, null, null);
  doc.setFontSize(8);
  doc.setFont('Helvetica', 'normal');
  doc.text(this.all_data.relatedToCustomer.C_name, 85, 48, null, null);
  doc.text(this.all_data.enduser_address, 85, 51, null, null);

  
  
 

  
  
  

  doc.setFontSize(10);
  doc.setFont('Helvetica', 'bold');
  doc.text('Quotation Code:', 200, 45, null, null, 'right');
  doc.setFontSize(8);
  doc.setFont('Helvetica', 'normal');
  doc.text(this.all_data.qu_code, 200, 49, null, null, 'right');


  doc.setFontSize(10);
  doc.setFont('Helvetica', 'bold');
  doc.text('Sales Person:', 200, 53, null, null, 'right');
  doc.setFontSize(8);
  doc.setFont('Helvetica', 'normal');
  doc.text(this.all_data.relatedToSalesperson.name, 200, 56, null, null, 'right');

  doc.setFontSize(10);
  doc.setFont('Helvetica', 'bold');
  doc.text('Payment Terms:', 200, 60, null, null, 'right');
  doc.setFontSize(8);
  doc.setFont('Helvetica', 'normal');
  doc.text(this.all_data.payment_method, 200, 63, null, null, 'right');
  
  doc.setFontSize(10);
  doc.setFont('Helvetica', 'bold');
  doc.text('Validity Period:', 200, 67, null, null, 'right');
  doc.setFontSize(8);
  doc.setFont('Helvetica', 'normal');
  doc.text(this.all_data.validity_period, 200, 70, null, null, 'right');




  doc.setFontSize(10);
  doc.setFont('Helvetica', 'bold');
  doc.text('Date:', 200, 74, null, null, 'right');
  doc.setFontSize(8);
  doc.setFont('Helvetica', 'normal');
  doc.text(this.all_data.received_date, 200, 77, null, null, 'right');
 
  const tableData = [
        ['No', 'Product Code', 'Product Description', 'Price', 'Qty', 'Discount %', 'Line Amount']
    ];
    

    this.details.forEach(detail => {
        tableData.push([
            detail.no,
            detail.P_code,
            detail.P_description,
            { content: detail.price, styles: { halign: 'right' } },
            { content: detail.qty, styles: { halign: 'right' } },
            { content: detail.line_discount, styles: { halign: 'right' } },
           
         
            { content: detail.line_amount, styles: { halign: 'right' } },
           
           
          
        ]);
    });

        // Add table to the PDF
        doc.autoTable({
            startY: 85, // Y position to start the table
            head: [tableData[0]], // Table header
            body: tableData.slice(1),
            addPageContent: function(data) {
        addPageBorders(doc); // Call the function to add page borders
    },
    styles: {
        font: 'Helvetica',
        fontSize:8,
    },
            // Table data excluding header
        });
 
        
        const tableBottomY = doc.lastAutoTable.finalY;

        doc.setFontSize(8);
        doc.setFont('Helvetica', 'bold');
        doc.text('Sub Total: '+this.total.total_line_amount, 195, tableBottomY+10, null, null, 'right');

        doc.setFontSize(8);
        doc.setFont('Helvetica', 'bold');
        doc.text('Special Discount: '+this.total.special_discount, 195, tableBottomY+18, null, null, 'right');

        doc.setFontSize(8);
        doc.setFont('Helvetica', 'bold');
        doc.text('Total :'+this.total.sub_total, 195, tableBottomY+26, null, null, 'right');

        doc.setFontSize(9);
        doc.setFont('Helvetica', 'normal');
        doc.text('* Cheques should be drawn in favour of “JANATHA AUTOMOBILES (PVT) LTD” & crossed A/C payee only.', 10, tableBottomY+45, null, null);
        doc.text('* Settlement should be made within 5 days', 10, tableBottomY+50, null, null);
        doc.text('* Any complaints should be informed within 3 days after receiving the goods.', 10, tableBottomY+55, null, null);
        doc.text('* Complaints after 3 days will not be accepted under any circumstances.', 10, tableBottomY+60, null, null);
        doc.text('* Bank Details : Commercial Bank (7056), Old Moor Street Branch (017), A/C No. 100 039 2638. ', 10, tableBottomY+65, null, null);
        doc.text('* The above Invoice is inclusive of all taxes.', 10, tableBottomY+70, null, null);
        


  
        doc.output('dataurlnewwindow');



    },
          async Confirm(id) {
       
    
       try {
         const { data} = await  axios.get('/servicejob/confirm?id='+id,{
           headers:{
             'Authorization':'Bearer '+this.access_token,
             'Content-type': 'application/json',
            
           }
          });
          console.log(data);
          if(data.status==200){
            this.loadSquatation();
           
            this.$root.$emit('bv::hide::modal', this.infoModal1.id);
        }
         
       } catch (error) {
         console.log(error.response);
       }
     },


     async crmCreate() {
       
    
       try {
         const { data} = await  axios.post('/cserviceevent/crmcreate?id='+this.id,{crm:this.crm,userid:this.userid},{
           headers:{
             'Authorization':'Bearer '+this.access_token,
             'Content-type': 'application/json',
            
           }
          });
          console.log(data);
          if(data.status==200){
            this.loadSquatation();
           
          
        }
         
       } catch (error) {
         console.log(error.response);
       }
     },



          async Update(){
        this.$router.push('/cmmsservicejob/update?id='+this.id);
      },




      async Confimmodel(){
        this.infoModal1.content = this.id;
       this.$root.$emit('bv::show::modal', this.infoModal1.id);
      
      },
          async Createinvoice(){
        this.$router.push('/serviceinvoice/create?id='+this.id);
      },

            async loadSquatation(id) {
        console.log("Amila");
      console.log(this.access_token);
      try {
        const { data} = await  axios.get('/cserviceevent/view?id='+this.id,{
          headers:{
            'Authorization':'Bearer '+this.access_token,
            'Content-type': 'application/json',
           
          }
         });
         console.log(data);
         this.all_data = data.all_data
       
         this.details = data.details
         this.total = data.total
         this.mservicelogs = data.mservicelogs || []
         this.isLoading = false;
       
        
      } catch (error) {
        console.log(error.response);
        this.isLoading = false;
      }
    },

  

        

  

    },
    
    }
    
    </script>

    <style scoped>
      /* @import "vue-select/dist/vue-select.css"; */
/* .vs__dropdown-option--disabled {
    display: block;
} */

.button-link {
  display: inline-block;
  padding: 5px 10px;
  font-size: small;
  text-decoration: none;
  color: #3899ea;
 
 
  
  cursor: pointer;
}

.button-link:hover {
  color: black;
  text-decoration: underline;
}
    </style>
